import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { Availability } from '../../entities/Availability';
import { apiRequests } from '../../shared/api/apiRequests';
import { toast } from 'react-toastify';
import './Team.css';

const CreateTeamStructurePage = () => {
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '',
    mainLanguageId: 1,
    Availability: {
      AvailableInAllCountries: true,
      AllowedCountriesIds: [],
      DisallowedCountriesIds: [],
    },
    SEOMetatags: {
      Title: '',
      Description: '',
      Keywords: '',
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) {
      toast.error('Введите название');
      return;
    }
    setSaving(true);
    try {
      await apiRequests.team.createTeamStructure(form);
      toast.success('Структура создана');
      navigate('/team-structures');
    } catch {
      toast.error('Ошибка создания');
    } finally {
      setSaving(false);
    }
  };

  const handleBack = () => navigate('/team-structures');

  return (
    <div className="team-page">
      <div className="team-header">
        <div>
          <button className="team-back" onClick={handleBack}>← Назад</button>
          <h1 className="team-title">Новая структура</h1>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="team-form">
        <div className="team-form-section">
          <h3 className="team-section-title">Основная информация</h3>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>Название <span className="required">*</span></label>
              <input
                type="text"
                value={form.title}
                onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
                placeholder="Введите название структуры"
                className="team-input"
              />
            </div>
            <div className="team-form-field" style={{ maxWidth: 200 }}>
              <LanguageOptions
                onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))}
              />
            </div>
          </div>
        </div>

        <div className="team-form-section" style={{ borderTop: '1px solid #f0f0f0' }}>
          <Availability
            onSelect={(val) =>
              setForm((prev) => ({
                ...prev,
                Availability: { ...prev.Availability, AvailableInAllCountries: val },
              }))
            }
            onSelectAllowed={(val) =>
              setForm((prev) => ({
                ...prev,
                Availability: { ...prev.Availability, AllowedCountriesIds: val.map(Number) },
              }))
            }
            onSelectDisallowed={(val) =>
              setForm((prev) => ({
                ...prev,
                Availability: { ...prev.Availability, DisallowedCountriesIds: val.map(Number) },
              }))
            }
          />
        </div>

        <div className="team-form-section" style={{ borderTop: '1px solid #f0f0f0' }}>
          <h3 className="team-section-title">SEO настройки</h3>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Title</label>
              <input
                type="text"
                value={form.SEOMetatags.Title}
                onChange={(e) => setForm((prev) => ({
                  ...prev,
                  SEOMetatags: { ...prev.SEOMetatags, Title: e.target.value },
                }))}
                placeholder="Заголовок для поисковиков"
                className="team-input"
              />
            </div>
          </div>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Description</label>
              <textarea
                value={form.SEOMetatags.Description}
                onChange={(e) => setForm((prev) => ({
                  ...prev,
                  SEOMetatags: { ...prev.SEOMetatags, Description: e.target.value },
                }))}
                placeholder="Описание для поисковиков"
                className="team-textarea"
              />
            </div>
          </div>
          <div className="team-form-row">
            <div className="team-form-field">
              <label>SEO Keywords</label>
              <input
                type="text"
                value={form.SEOMetatags.Keywords}
                onChange={(e) => setForm((prev) => ({
                  ...prev,
                  SEOMetatags: { ...prev.SEOMetatags, Keywords: e.target.value },
                }))}
                placeholder="Ключевые слова через запятую"
                className="team-input"
              />
            </div>
          </div>
        </div>

        <div className="team-form-actions">
          <button type="button" className="team-btn-cancel" onClick={handleBack}>
            Отмена
          </button>
          <button type="submit" className="team-btn-submit" disabled={saving}>
            {saving ? 'Создание...' : 'Создать структуру'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateTeamStructurePage;
